<template>
  <DxPopup
    :visible="getVisible"
    @hidden="onPopupHide"
    :drag-enabled="false"
    :hide-on-outside-click="false"
    :show-close-button="false"
    :show-title="true"
    :width="'75%'"
    :height="getPopupHeight"
    :title="popupConfig.title"
    :wrapper-attr="{
      class: 'css-v2 gc-popup gc-popup-form gc-popup-shifts',
    }"
    ref="gc-popup"
    @shown="onShown"
    @initialized="onInitialized"
  >
    <DxToolbarItem
      v-if="popupConfig.formMode !== 'create' && popupConfig.secondaryTitle"
      location="before"
      :html="`<span class='toolbar-title-secondary text-secondary'> ${popupConfig.secondaryTitle}</span>`"
    ></DxToolbarItem>

    <DxToolbarItem
      v-for="(item, index) in getToolbarItems"
      :key="index"
      :widget="item.widget"
      :location="item.location"
      :visible="item.visible"
      :toolbar="item.position"
      :options="item.options"
      :template="item.template ? item.template : null"
    />

    <div class="css-v2 gc-popup-form">
      <GcForm
        :key="popupConfig.formKey"
        :formOptions="{
          gcLabelLocation: 'left',
        }"
        :formItems="getHeaderFormItems"
        :isNormal="true"
        :data-model="model"
        :formMode="popupConfig.formMode"
        :validationGroup="'gc-form-comp-shifts'"
        :formLocation="'normal'"
        :formHeight="250"
        ref="gc-form-comp-shifts"
        :valueChangeCallBack="valueChangeCallBack"
        :checkValid="isValid"
      />
    </div>

    <div class="css-v2 gc-popup-data-grid" v-show="IsProcessException">
      <div class="data-grid-content">
        <div>
          <dx-data-grid
            v-if="IsProcessException"
            :data-source="getDataSource"
            :columns="getColumns"
            :show-borders="true"
            :height="334"
            :row-alternation-enabled="true"
            :columnChooser="{
              enabled: false,
            }"
            :pager="{ visible: false }"
            :column-auto-width="false"
            @toolbar-preparing="onToolbarPreparing($event)"
            @editor-preparing="onEditorPreparing"
            @content-ready="onContentReady"
            @row-removed="onRowRemoved"
            @editing-start="onEditingStart"
            :ref="'shifts-tab-grid-downtime'"
            :key-expr="'id'"
          >
            <DxEditing
              :allow-deleting="popupConfig.formMode !== 'review'"
              :allow-updating="popupConfig.formMode !== 'review'"
              :mode="'cell'"
              :confirm-delete="false"
            />

            <template #manageDownTimeCellTemplate="{ data }">
              <div class="manage-downtime">
                <dx-button
                  :text="'Manage Downtime'"
                  :width="120"
                  :disabled="!isProcessDownTimeEditable"
                  @click="onProcessExceptionDowntimeClick(data)"
                />
              </div>
            </template>
          </dx-data-grid>
        </div>
      </div>
    </div>

    <DxLoadPanel
      :position="{ of: '#container-wrapper' }"
      :visible.sync="loadingVisible"
      :show-indicator="true"
      :show-pane="true"
      :shading="true"
      :hide-on-outside-click="false"
      shading-color="rgba(0,0,0,0)"
    />

    <GcPopupAudit
      v-if="popupAuditVisible"
      :showPopup.sync="popupAuditVisible"
      :model.sync="auditModel"
    />

    <GcPopupShiftExceptionDowntime
      :popupConfig="ShiftExceptionDowntimePopupConfig"
      :data-model="dataModel"
      :on-hide="onShiftExceptionDowntimePopupHide"
      v-if="ShiftExceptionDowntimePopupConfig.isPopupShow"
      :displayServerError="displayServerError"
      @onSaveShiftExceptionDowntime="onSaveShiftExceptionDowntime"
    />

    <GcPopupProcessShiftRecurringDowntime
      :popupConfig="DowntimeDeductionPopupConfig"
      :data-model="dataModel"
      :on-hide="onDowntimeDeductionPopupHide"
      v-if="
        DowntimeDeductionPopupConfig.isPopupShow &&
        DowntimeDeductionPopupConfig.Deduction === false
      "
      :displayServerError="displayServerError"
      @onSaveRecurringDowntime="onSaveRecurringDowntime"
    />
  </DxPopup>
</template>
<script>
import DataGridMixin from "@/_mixins/data-grid.mixin";
import { mapGetters } from "vuex";
import { ProcessCapacityService } from "../../_services/api/production/process-capacity.service";
import { FeatureStorage } from "../../_services/storage";
import ArrayStore from "devextreme/data/array_store";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";
import {
  durationToTime,
  from24toDate,
  to24Hour,
} from "../../_helpers/ui/helpers";
import GcPopupShiftExceptionDowntime from "./gc-popup-shift-exception-downtime.vue";

import { DateFromIsoWithoutZ } from "../../_helpers/prototypes/prototype-date";
import { backwardTabbing, forwardTabbing } from "../../_helpers/ui/keyboard";
import GcPopupProcessShiftRecurringDowntime from "./gc-popup-process-shift-recurring-downtime.vue";

const shiftProcessBaseLine = {
  id: null,
  ProcessCode: null,
  ProcessRecordId: null,
  ProcessDescription: null,
  StartTime: null,
  EndTime: null,
  StartTimeEnter: false,
  EndTimeEnter: false,
  ProcessExceptionDownTimeRecordsFetched: false,
};

export default {
  mixins: [DataGridMixin],
  components: {
    GcPopupShiftExceptionDowntime,
    GcPopupProcessShiftRecurringDowntime,
  },
  data() {
    return {
      IsFormLoaded: false,
      popupHeight: 355,
      model: {
        ExceptionType: null,
        ShiftExceptionReasonRecordID: null,
        Action: null,
        DateStart: null,
        DateEnd: null,
        StartTime: null,
        EndTime: null,
        Comment: null,
        RecordID: null,
        ShiftRecordID: null,
        HasUniqueDownTime: false,
      },

      ShiftExceptionDownTimeDataSource: new ArrayStore({
        key: "id",
        data: [],
      }),

      isValid: false,
      loadingVisible: false,
      SelectedIndex: 0,
      ProcessShiftExceptionDataSource: new ArrayStore({
        key: "id",
        data: [],
      }),
      popupAuditVisible: false,
      auditModel: {
        createdBy: "",
        dateCreated: "",
        changedBy: "",
        dateChanged: "",
      },

      ShiftExceptionDowntimePopupConfig: {
        title: "",
        secondaryTitle: undefined,
        isFormLoading: false,
        popupKey: 0,
        formKey: 0,
        height: 500,
        isPopupShow: false,
        hideOnOutsideClick: false,
        formMode: "edit",
        isEditable: false,
        dataModel: undefined,
      },

      // Process Exception
      IsProcessException: false,
      IsShiftException: false,
      ShiftRecordID: null,
      DowntimeDeductionPopupConfig: {
        Deduction: false,
        title: "",
        secondaryTitle: undefined,
        isFormLoading: false,
        popupKey: 0,
        formKey: 0,
        height: 500,
        isPopupShow: false,
        hideOnOutsideClick: false,
        formMode: "edit",
        isEditable: false,
        dataModel: undefined,
      },
      ExceptionDownTimeRecordsFetched: false,
    };
  },
  props: {
    popupConfig: {
      type: Object,
      default: () => {
        return {
          isPopupShow: false,
          formMode: "create",
          formKey: 1,
          secondaryTitle: "",
        };
      },
    },
    wrapperAttr: {
      type: Object,
      default: () => {},
    },
    dataModel: {
      type: Object,
      default: () => {},
    },
    showLoading: {
      type: Function,
      default: () => {},
    },
    displayServerError: {
      type: Function,
      default: function () {},
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
    onHide: {
      type: Function,
      default: () => {},
    },
  },
  async created() {},
  methods: {
    // async resetModelData() {
    //   this.model.ExceptionType = null;
    //   // this.model.ShiftExceptionReasonRecordID = null;
    //   this.model.Action = null;
    //   this.model.DateStart = null;
    //   this.model.DateEnd = null;
    //   this.model.StartTime = null;
    //   this.model.EndTime = null;
    //   this.model.Comment = null;
    //   // this.model.ShiftRecordID = null;
    //   this.model.HasUniqueDownTime = false;
    //   this.model.RecordID = null;
    // },
    /* Popup Events */
    async onShown() {
      this.loadingVisible = true;
      // this.resetModelData();
      this.model = {
        ExceptionType: null,
        // ShiftExceptionReasonRecordID: null,
        Action: null,
        DateStart: null,
        DateEnd: null,
        StartTime: null,
        EndTime: null,
        Comment: null,
        RecordID: null,
        // ShiftRecordID: null,
        HasUniqueDownTime: false,
      };

      if (this.dataModel) {
        this.model = { ...this.model };

        this.model.RecordID = this.dataModel.RecordID;
        this.model.ExceptionType = this.dataModel.ExceptionType;
        this.model.ShiftRecordID = this.dataModel.ShiftRecordID;
        this.model.ShiftExceptionReasonRecordID =
          this.dataModel.ShiftExceptionReasonRecordID;
        this.model.Comment = this.dataModel.Comment;
        this.model.HasUniqueDownTime = this.dataModel.HasUniqueDownTime;

        this.model.Action = this.dataModel.IsIncluded
          ? "AlterShiftInstance"
          : "RemoveShiftInstance";

        if (this.dataModel.DateStart) {
          this.model.DateStart = DateFromIsoWithoutZ(this.dataModel.DateStart);
          this.model.StartTime = DateFromIsoWithoutZ(this.dataModel.DateStart);
        }

        if (this.dataModel.DateEnd) {
          this.model.DateEnd = DateFromIsoWithoutZ(this.dataModel.DateEnd);
          this.model.EndTime = DateFromIsoWithoutZ(this.dataModel.DateEnd);
        }

        if (this.dataModel.ShiftRecordID) {
          this.ShiftRecordID = { _value: this.dataModel.ShiftRecordID };
        }

        this.IsProcessException =
          this.dataModel.ExceptionType === "Process" ? true : false;
        this.IsShiftException =
          this.dataModel.ExceptionType === "Shift" ? true : false;

        if (this.IsShiftException) {
          const downTimeResponse =
            await ProcessCapacityService.getExceptionDownTime(
              "Shift",
              this.model.RecordID,
              "",
              "",
              "",
            );
          this.dataModel.ShiftExceptionDownTime = downTimeResponse.data || [];
          this.ExceptionDownTimeRecordsFetched = true;

          this.ShiftExceptionDownTimeDataSource.clear();
          if (
            this.dataModel.ShiftExceptionDownTime &&
            this.dataModel.ShiftExceptionDownTime.length > 0
          ) {
            this.dataModel.ShiftExceptionDownTime.forEach((item) => {
              item.Description = item.Name;
              item.StartTime = durationToTime(item.StartTime);
              item.EndTime = durationToTime(item.EndTime);
              item.DurationMins = item.Minutes;

              this.ShiftExceptionDownTimeDataSource.insert({
                ...item,
              });
            });
          }
        }

        if (this.IsProcessException) {
          const processLine = {
            ProcessCode: this.dataModel.ProcessCode,
            ProcessDescription: this.dataModel.ProcessName,
            ProcessRecordId: this.dataModel.ProcessRecordID,
            StartTime:
              this.dataModel.DateStart && this.dataModel.IsIncluded
                ? DateFromIsoWithoutZ(this.dataModel.DateStart)
                : null,
            EndTime:
              this.dataModel.DateEnd && this.dataModel.IsIncluded
                ? DateFromIsoWithoutZ(this.dataModel.DateEnd)
                : null,
            HasUniqueDownTime: this.dataModel.HasUniqueDownTime || false,
            ProcessExceptionDownTimeRecordsFetched: true,
          };

          try {
            const response = await ProcessCapacityService.getExceptionDownTime(
              "Process",
              this.model.RecordID,
              "",
              "",
              "",
            );

            const resData = response.data;
            if (resData && resData.length > 0) {
              processLine.ProcessShiftRecurringDownTimes = resData.map(
                (item) => {
                  return {
                    ...item,
                    StartTime: durationToTime(item.StartTime),
                    EndTime: durationToTime(item.EndTime),
                    DurationMins: item.Minutes,
                    Description: item.Name,
                    SavedItem: true,
                  };
                },
              );
            }
          } catch (error) {
            this.displayServerError(error);
          }

          this.ProcessShiftExceptionDataSource.insert(processLine);
        }

        // Audit Model
        this.auditModel.createdBy = this.dataModel.CreatedBy;
        this.auditModel.dateCreated = this.dataModel.DateCreated;
        this.auditModel.changedBy = this.dataModel.ChangedBy;
        this.auditModel.dateChanged = this.dataModel.DateChanged;
      }
      await this.initializeModel();
      this.$store.dispatch("hotKey/setHotKeyPopupMode", true);
      this.$nextTick(() => {
        this.loadingVisible = false;
        this.setFocusOnField(
          this.popupConfig.formMode === "create"
            ? "ExceptionType"
            : "ShiftRecordID",
        );
      });
    },

    async initializeModel() {
      if (this.popupConfig.formMode === "create") {
        this.ProcessShiftExceptionDataSource.insert({
          ...shiftProcessBaseLine,
        });
      } else {
        // Review or Edit
      }
    },

    async onRemoveExceptionHandler() {
      let confirm = await this.$confirm(
        "Are you sure to remove this exception?",
        "Confirmation",
      );

      if (confirm) {
        this.loadingVisible = true;

        const action = this.IsProcessException
          ? ProcessCapacityService.deleteProcessShiftException(
              this.model.RecordID,
            )
          : ProcessCapacityService.deleteShiftException(this.model.RecordID);
        try {
          await action;
          await this.$notify("Exception has been deleted", "success");
          this.onPopupHide();
        } catch (error) {
          this.displayServerError(error);
        } finally {
          this.loadingVisible = false;
        }
      }
    },

    async onManageShiftExceptionDowntimeClick() {
      if (!this.model.ShiftRecordID) {
        await this.$alert(
          `Select a shift before managing downtime.`,
          "Validation Error",
        );
        return;
      }

      this.loadingVisible = true;

      try {
        if (this.ExceptionDownTimeRecordsFetched === false) {
          this.ShiftExceptionDownTimeDataSource.clear();
          const shiftDowntimeRes =
            await ProcessCapacityService.getExceptionDownTime(
              "Shift",
              this.popupConfig.formMode === "create" ? "" : this.model.RecordID,
              this.popupConfig.formMode === "create"
                ? this.model.ShiftRecordID
                : "",
              "",
              "",
            );
          if (shiftDowntimeRes.data) {
            this.ExceptionDownTimeRecordsFetched = true;
            shiftDowntimeRes.data.forEach((item) => {
              item.Description = item.Name;
              item.StartTime = durationToTime(item.StartTime);
              item.EndTime = durationToTime(item.EndTime);
              item.DurationMins = item.Minutes;

              this.ShiftExceptionDownTimeDataSource.insert({
                ...item,
              });
            });
          }
        }
        await this.openShiftExceptionDowntimePopup(
          this.ShiftExceptionDownTimeDataSource,
        );
      } catch (error) {
        this.displayServerError(error);
      } finally {
        this.loadingVisible = false;
      }
    },

    async openShiftExceptionDowntimePopup(downTimesData) {
      //
      let shiftRes = await ProcessCapacityService.getShiftByRecordId(
        this.model.ShiftRecordID,
      );
      let shiftCode = shiftRes.data.value[0].Code;
      let shiftDescription = shiftRes.data.value[0].Description;
      //
      this.ShiftExceptionDowntimePopupConfig = {
        ...this.ShiftExceptionDowntimePopupConfig,
        title: "Manage Downtime for " + shiftCode + " - " + shiftDescription,
        formMode: this.popupConfig.formMode,
        downTimesData: downTimesData,
        dataModel: this.model,
        isPopupShow: true,
      };
    },

    onShiftExceptionDowntimePopupHide() {
      this.ShiftExceptionDowntimePopupConfig.isPopupShow = false;
      this.ShiftExceptionDowntimePopupConfig.dataModel = undefined;
      this.ShiftExceptionDowntimePopupConfig.downTimesData = undefined;
      this.ShiftExceptionDowntimePopupConfig.secondaryTitle = undefined;
    },

    onSaveShiftExceptionDowntime(downTimes) {
      this.ShiftExceptionDownTimeDataSource.clear();
      downTimes.forEach((item) => {
        this.ShiftExceptionDownTimeDataSource.insert({
          ...item,
        });
      });
      this.model.HasUniqueDownTime = true;
      this.onShiftExceptionDowntimePopupHide();
    },

    addNewEditableRow() {
      this.ProcessShiftExceptionDataSource.insert({
        ...shiftProcessBaseLine,
      });
    },

    /*
    Popup Hide Event
    */
    onPopupHide(repaint = true) {
      this.$emit("setIsVisible", false);

      this.onHide(repaint);
      this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
    },

    /**
     * Popup Initialized Event
     * @param e
     */
    onInitialized(e) {
      this.IsFormLoaded = true;
      e.component.registerKeyHandler("escape", (arg) => {
        arg.stopPropagation();

        this.$nextTick(() => {
          this.onCancelPopupHandler();
        });
      });
    },

    /**
     * Cancel Popup Handler
     */
    async onCancelPopupHandler() {
      if (this.popupConfig.formMode === "review") {
        this.onPopupHide(false);
        return;
      }
      if (this.popupConfig.isPopupShow) {
        const confirm = await this.$confirm(
          `You have unsaved changes. Are you sure you want to leave?`,
          "Unsaved changes",
          {
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            type: "warning",
          },
        );
        if (confirm) {
          this.onPopupHide(false);
        }
      }
    },

    /**
     * Set Focus On Field
     * @param dataField
     */
    setFocusOnField(dataField) {
      if (this.popupConfig.formMode !== "review") {
        if (this.getFormInstance) {
          const form = this.getFormInstance.instance;
          form.getEditor(dataField).focus();
        }
      }
    },

    async focusOutFromEditableCells() {
      var dataGrid = this.dataGrid;
      const activeElement = document.activeElement;
      if (activeElement) {
        activeElement.blur();
        if (dataGrid) dataGrid.saveEditData();
      }
    },

    onSavePopupHandler() {
      this.focusOutFromEditableCells();
      this.isValid = true;
    },
    /**
     * Value Change Call Back
     * @param isValid Validation Status
     * @param brokenRules
     */
    async valueChangeCallBack(isValid, brokenRules) {
      var validations = "";
      this.isValid = false;

      if (!isValid) {
        brokenRules.forEach((element) => {
          validations += `<div style="width: 400px; padding-bottom: 5px;">${element.message}</div>`;
        });

        try {
          await this.$alert(validations, "Validation Error", {
            width: 400,
          });
        } catch (error) {
          // User might have pressed ESC, but we still need to reset
        }
      } else {
        // Shift Exception Save Here

        const isEdit = this.popupConfig.formMode === "edit";

        const DateStart = this.model.DateStart
          ? new Date(this.model.DateStart).toSaveDate()
          : null;

        const IsIncluded =
          this.model.Action == "RemoveShiftInstance" ? false : true;

        let finalResult = {
          // ExceptionType: this.model.ExceptionType,
          ShiftExceptionReasonRecordId: this.model.ShiftExceptionReasonRecordID,
          ShiftRecordID: this.model.ShiftRecordID,
          DateStart: DateStart,
          DateEnd: this.model.DateEnd
            ? new Date(this.model.DateEnd).toSaveDate()
            : DateStart
            ? DateStart
            : null,
          Comment: this.model.Comment ? this.model.Comment.trimEnd() : "",
          IsIncluded: IsIncluded,
        };

        if (this.IsProcessException) {
          // save process shift exception
          finalResult.ProcessShiftExceptionLines = [];

          const validLines = this.ProcessShiftExceptionDataSource._array.filter(
            (line) => {
              return line.ProcessCode;
            },
          );

          if (validLines.length === 0) {
            await this.$alert(
              `Please enter at least one process line with valid process code.`,
              "Validation Error",
            );
            this.focusOnEditableGridCell("ProcessCode");
            return;
          }

          if (this.model.Action === "AlterShiftInstance") {
            const checkValidDates =
              this.ProcessShiftExceptionDataSource._array.some((line) => {
                return line.ProcessCode && (!line.StartTime || !line.EndTime);
              });

            if (checkValidDates) {
              await this.$alert(
                `Please ensure all process lines have valid start and end times.`,
                "Validation Error",
              );
              return;
            }
          }

          this.ProcessShiftExceptionDataSource._array.forEach((line) => {
            if (line.ProcessCode) {
              const ProcessException = {
                ProcessRecordId: line.ProcessRecordId,
                StartTime:
                  line.StartTime && IsIncluded
                    ? to24Hour(line.StartTime)
                    : null,
                EndTime:
                  line.EndTime && IsIncluded ? to24Hour(line.EndTime) : null,
                HasUniqueDownTime: line.HasUniqueDownTime || false,
                ProcessShiftExceptionDownTimes: [],
              };

              if (
                line.ProcessShiftRecurringDownTimes &&
                line.ProcessShiftRecurringDownTimes.length > 0 &&
                line.HasUniqueDownTime
              ) {
                line.ProcessShiftRecurringDownTimes.forEach((dt) => {
                  if (dt.SavedItem !== true) return;

                  const startTimeStr = dt.StartTime
                    ? to24Hour(dt.StartTime)
                    : null;
                  const endTimeStr = dt.EndTime ? to24Hour(dt.EndTime) : null;

                  const downtime = {
                    Name: dt.Description.trimEnd(),
                    StartTime: startTimeStr,
                    EndTime: endTimeStr,
                  };

                  if (dt.RecordId) {
                    downtime.RecordId = dt.RecordId;
                  }
                  ProcessException.HasUniqueDownTime = true;
                  ProcessException.ProcessShiftExceptionDownTimes.push(
                    downtime,
                  );
                });
              }

              finalResult.ProcessShiftExceptionLines.push(ProcessException);
            }
          });
        } else {
          // save shift exception
          finalResult.ExceptionType = this.model.ExceptionType;
          finalResult.HasUniqueDownTime = this.model.HasUniqueDownTime;
          finalResult.StartTime =
            this.model.Action == "RemoveShiftInstance"
              ? null
              : this.model.StartTime
              ? to24Hour(this.model.StartTime)
              : null;
          finalResult.EndTime =
            this.model.Action == "RemoveShiftInstance"
              ? null
              : this.model.EndTime
              ? to24Hour(this.model.EndTime)
              : null;
          finalResult.ShiftExceptionDownTimes = [];
          //
          if (
            this.ShiftExceptionDownTimeDataSource._array.length > 0 &&
            this.model.Action == "AlterShiftInstance" &&
            this.model.HasUniqueDownTime
          ) {
            this.ShiftExceptionDownTimeDataSource._array.forEach((dt) => {
              const startTimeStr = dt.StartTime ? to24Hour(dt.StartTime) : null;
              const endTimeStr = dt.EndTime ? to24Hour(dt.EndTime) : null;

              const downtime = {
                Name: dt.Description.trimEnd(),
                StartTime: startTimeStr,
                EndTime: endTimeStr,
              };

              if (dt.RecordID) {
                downtime.RecordId = dt.RecordID;
              }
              finalResult.ShiftExceptionDownTimes.push(downtime);
            });
          }
        }

        if (isEdit) {
          finalResult.RecordId = this.model.RecordID;
        }

        const successMessage = isEdit
          ? this.IsProcessException
            ? "Process shift exception updated successfully."
            : "Shift exception updated successfully."
          : this.IsProcessException
          ? "Process shift exception saved successfully."
          : "Shift exception saved successfully.";

        this.loadingVisible = true;

        const action = this.IsProcessException
          ? ProcessCapacityService.saveSaveProcessShiftException(finalResult)
          : ProcessCapacityService.saveShiftException(finalResult);
        try {
          let exceptionResult = await action;
          if (exceptionResult.data.ShowSkipDaysWarning) {
            await this.$alert(
              `Some dates were skipped because the process is not active in the shift on those days. The exception has been created only for valid dates.`,
              "Warning",
            );
          }
          await this.$notify(successMessage, "success");
          this.onPopupHide();
        } catch (error) {
          this.displayServerError(error);
        } finally {
          this.loadingVisible = false;
        }
      }

      // Always reset isValid after processing
      this.$nextTick(() => {
        this.isValid = false;
      });
    },

    /**
     * Handle Audit Popup
     */
    onAuditPopupHandler() {
      this.popupAuditVisible = !this.popupAuditVisible;
    },

    onEditPopupHandler() {
      this.popupConfig.title =
        this.model.ExceptionType === "ProcessException"
          ? "Edit Process Shift Exception"
          : "Edit Shift Exception";
      this.popupConfig.formMode = "edit";
      this.popupConfig.formKey++;

      // this.ProcessShiftExceptionDataSource.insert({
      //   ...shiftProcessBaseLine,
      // });

      this.$nextTick(() => {
        setTimeout(() => this.setFocusOnField("ShiftRecordID"), 700);
      });
    },

    onDateStartChange(e) {
      if (!e.event) return;

      this.model.DateEnd = null;

      this.$nextTick(() => {
        this.setFocusOnField("DateEnd");
      });
    },

    onStartTimeChange(e) {
      if (!e.event) return;

      this.$nextTick(() => {
        if (this.model.Action === "RemoveShiftInstance") {
          this.setFocusOnField("Comment");
        } else {
          // this.setFocusOnField("StartTime");
        }
      });
    },

    /**
     * on so list grid toolbar preparing
     * @param e - event
     */
    onToolbarPreparing(e) {
      e.toolbarOptions.visible = false;
    },

    onContentReady(e) {
      setTimeout(() => {
        this.$nextTick(() => {
          e.component.beginUpdate();
          e.component.updateDimensions();
          e.component.endUpdate();

          this.addGridNoResults(e, {
            addNew: {
              class: "no-data",
              title: "No Process Exception",
              message: "No Process Exception found.",
            },
          });
        });
      }, 2000);
    },

    onEditorPreparing(e) {
      if (e.parentType !== "searchPanel") {
        const { dataField, editorOptions, row } = e;
        // Only wrap handlers if not in the search panel
        if (!editorOptions) return;

        const wrapHandler = (handlerName) => {
          const original = editorOptions[handlerName];
          if (typeof original === "function") {
            editorOptions[handlerName] = (event) => {
              original(event, {
                column: { dataField },
                data: row.data,
                rowIndex: row.rowIndex,
              });
            };
          }
        };

        // Wrap each handler if it exists
        [
          "onFocusIn",
          "onFocusOut",
          "onKeyDown",
          "onValueChanged",
          "onInput",
          "onOpened",
        ].forEach(wrapHandler);
      }

      if (e.dataField && e.dataField == "ProcessCode") {
        e.editorName = "dxSelectBox";
      }
    },
    async onRowRemoved(e) {
      if (!e) return;
      let items = await this.ProcessShiftExceptionDataSource.load();

      if (items.length === 0) {
        this.addNewEditableRow();
      } else if (items[items.length - 1].ProcessCode !== null) {
        this.addNewEditableRow();
      }
    },

    async onEditingStart(e) {
      if (!e) return;

      if (e.column) {
        const column = e.column;
        const data = e.data;

        if (!data) return;
        if (
          (column.dataField === "StartTime" ||
            column.dataField === "EndTime") &&
          this.model.Action === "RemoveShiftInstance"
        ) {
          e.cancel = true;
        }

        if (this.popupConfig.formMode === "edit") {
          if (column.dataField === "ProcessCode") {
            e.cancel = true;
          }
        }
      }
    },

    focusOnEditableGridCell(dataField, rowData = null) {
      if (this.dataGrid) {
        const dataGrid = this.dataGrid;
        let rowIndex = 0;
        if (rowData) {
          rowIndex = dataGrid.getRowIndexByKey(rowData.id);
        }

        if (rowIndex === -1) return;
        const cellElement = dataGrid.getCellElement(rowIndex, dataField);
        dataGrid.focus(cellElement);
        setTimeout(() => {
          dataGrid.editCell(rowIndex, dataField);
        }, 10);
      }
    },

    // Process Exception Functions
    onExceptionTypeChange(value) {
      this.model.ExceptionType = value;
      if (value === "Process") {
        this.IsProcessException = true;
        this.IsShiftException = false;
      } else {
        this.IsShiftException = true;
        this.IsProcessException = false;
      }
    },

    forwardTabFromProcessCode(lineData) {
      const rowIndex = lineData.rowIndex;
      if (rowIndex === this.dataGrid.totalCount() - 1) {
        this.setFocusOnField("ExceptionType");
      } else {
        this.dataGrid.focus(
          this.dataGrid.getCellElement(rowIndex + 1, "ProcessCode"),
        );
        this.dataGrid.editCell(rowIndex + 1, "ProcessCode");
      }
    },

    onShiftValueChanged(e) {
      if (this.IsShiftException) {
        this.ExceptionDownTimeRecordsFetched = false;
        this.model.HasUniqueDownTime = false;
      }

      if (this.IsProcessException) {
        this.ProcessShiftExceptionDataSource.clear();
        this.ProcessShiftExceptionDataSource.insert({
          ...shiftProcessBaseLine,
        });
      }

      if (e && e.value) {
        this.ShiftRecordID = { ...e.value };
      } else this.ShiftRecordID = null;

      this.$nextTick(() => {
        this.setFocusOnField("ShiftExceptionReasonRecordID");
      });
    },

    onShiftSelectionChanged(e) {
      if (!e.selectedItem) {
        this.model.ShiftStartTime = null;
        this.model.ShiftEndTime = null;
        return;
      }
      const selectedItem = e.selectedItem;
      this.model.ShiftStartTime = from24toDate(selectedItem.StartTime);
      this.model.ShiftEndTime = from24toDate(selectedItem.EndTime);
    },

    async onProcessExceptionDowntimeClick(data) {
      await this.focusOutFromEditableCells();

      if (!data) return;

      if (this.model.DateStart == null || this.model.DateEnd == null) {
        await this.$alert(
          `Please enter valid start and end dates before managing downtime.`,
          "Validation Error",
        );
        this.setFocusOnField("DateStart");
        return;
      }

      const rowData = data.data;
      if (!rowData) return;
      if (!rowData.ProcessCode) {
        await this.$alert(
          `Please select a process before managing downtime.`,
          "Validation Error",
        );
        this.focusOnEditableGridCell("ProcessCode", rowData);
        return;
      } else if (
        this.model.Action === "AlterShiftInstance" &&
        (!rowData.StartTime || !rowData.EndTime)
      ) {
        await this.$alert(
          `Please enter valid start and end times before managing downtime.`,
          "Validation Error",
        );
        this.focusOnEditableGridCell("StartTime", rowData);
        return;
      } else {
        const mode = this.popupConfig.formMode;

        const titleMap = {
          create: `Manage Downtime`,
          edit: `Manage Downtime`,
          review: `Manage Downtime`,
        };

        if (!rowData.ProcessExceptionDownTimeRecordsFetched) {
          rowData.ProcessShiftRecurringDownTimes = [];

          if (this.getShiftRecordID) {
            this.loadingVisible = true;
            try {
              let response;
              if (this.popupConfig.formMode === "create") {
                response = await ProcessCapacityService.getExceptionDownTime(
                  "Process",
                  "",
                  this.getShiftRecordID,
                  rowData.ProcessRecordId._value,
                  new Date(this.model.DateStart).toSaveDate(),
                );
              } else {
                response = await ProcessCapacityService.getExceptionDownTime(
                  "Process",
                  this.model.RecordID,
                  "",
                  "",
                  "",
                );
              }

              const resData = response.data;
              if (resData && resData.length > 0) {
                rowData.ProcessExceptionDownTimeRecordsFetched = true;
                rowData.ProcessShiftRecurringDownTimes = resData.map((item) => {
                  return {
                    ...item,
                    StartTime: durationToTime(item.StartTime),
                    EndTime: durationToTime(item.EndTime),
                    DurationMins: item.Minutes,
                    Description: item.Name,
                  };
                });
              }
            } catch (error) {
              this.displayServerError(error);
            } finally {
              this.loadingVisible = false;
            }
          }
        }

        const ShiftStartTime =
          this.model.Action === "AlterShiftInstance"
            ? rowData.StartTime
            : this.model.ShiftStartTime;
        const ShiftEndTime =
          this.model.Action === "AlterShiftInstance"
            ? rowData.EndTime
            : this.model.ShiftEndTime;

        this.DowntimeDeductionPopupConfig = {
          ...this.DowntimeDeductionPopupConfig,
          Deduction: false,
          title: titleMap[mode],
          formMode: mode,
          dataModel: { ...rowData },
          isPopupShow: true,
          secondaryTitle:
            mode !== "create"
              ? `for ${rowData.ProcessCode} - ${rowData.ProcessDescription}`
              : undefined,
          shiftData: {
            StartTime: ShiftStartTime,
            EndTime: ShiftEndTime,
          },
        };
      }
    },

    onDowntimeDeductionPopupHide() {
      this.DowntimeDeductionPopupConfig.isPopupShow = false;
      this.DowntimeDeductionPopupConfig.dataModel = undefined;
      this.DowntimeDeductionPopupConfig.Deduction = false;
      this.DowntimeDeductionPopupConfig.secondaryTitle = undefined;
    },
    onSaveRecurringDowntime(downTimes) {
      const data = this.DowntimeDeductionPopupConfig.dataModel;

      if (downTimes && downTimes.length > 0) {
        downTimes.forEach((dt) => {
          dt.Name = dt.Description;
          dt.SavedItem = true;
        });
      }

      // Update the ProcessShiftExceptionDataSource with the new downtime entries
      this.ProcessShiftExceptionDataSource.update(data.id, {
        HasUniqueDownTime: true,
        ProcessShiftRecurringDownTimes: downTimes,
      });

      this.onDowntimeDeductionPopupHide();
    },

    onEndTimeChange(e) {
      if (!e.event) return;

      this.model.EndTime = e.value;
    },

    uniqueProcesses(data) {
      return Array.from(new Map(data.map((p) => [p.ProcessCode, p])).values());
    },
  },
  computed: {
    ...mapGetters({ getHotKeySave: "hotKey/getHotKeySave" }),
    getVisible() {
      if (this.popupConfig.isPopupShow) return this.popupConfig.isPopupShow;
      else return false;
    },
    /**
     * Get Header Form Items
     */
    getHeaderFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 2,
          items: [
            // First Row: Exception Type (1 column) and Shift (1 columns)
            {
              dataField: "ExceptionType",
              label: { text: "Exception Type", location: "left" },
              editorType: "dxSelectBox",
              colSpan: 1,
              editorOptions: {
                dataSource: [
                  { type: "Shift", Name: "Shift Exception" },
                  { type: "Process", Name: "Process Exception" },
                ],
                displayExpr: "Name",
                valueExpr: "type",
                tabIndex: this.popupConfig.formMode === "create" ? 1 : -1,
                readOnly: this.popupConfig.formMode === "edit",
                onValueChanged: (e) => {
                  if (!e.event) return;

                  this.$nextTick(() => {
                    this.onExceptionTypeChange(e.value);
                  });
                },
              },
              validationRules: [
                {
                  type: "required",
                  message: "Exception Type is required",
                },
              ],
            },
            {
              dataField: "ShiftRecordID",
              label: { text: "Shift", location: "left" },
              editorType: "dxSelectBox",
              colSpan: 1,
              editorOptions: {
                tabIndex: this.popupConfig.formMode === "create" ? 2 : -1,
                readOnly: this.popupConfig.formMode === "edit",
                dataSource: ProcessCapacityService.dataSourceConfig(
                  "api/ShiftList",
                  {
                    filter: [["Inactive", "=", "N"]],
                    sort: "Code asc",
                    select: "Code, Description, RecordId, StartTime, EndTime",
                    keyType: {
                      RecordId: "Guid",
                    },
                    fieldType: {
                      RecordId: "Guid",
                    },
                  },
                ),
                displayExpr: (item) => {
                  if (item) return item.Code + " - " + item.Description;
                  else return "";
                },
                valueExpr: "RecordId",
                searchEnabled: true,
                searchExpr: ["Code", "Description"],
                itemTemplate: (data) => {
                  return ` <div class="custom-auto-complete" id="${data.RecordId}" >
                  <span class="auto-complete-primary">
                    ${data.Code}
                    </span>
                    <span class="record-secondary gc-grid-code">
                      ${data.Description}
                  </span>
                </div>`;
                },
                dropDownOptions: {
                  minWidth: 200,
                },
                onFocusIn: (e) => {
                  if (!e.event) return;
                  e.event.target.select();
                },
                onValueChanged: (e) => {
                  if (!e.event) return;

                  this.onShiftValueChanged(e);
                },
                onSelectionChanged: (e) => {
                  if (!e) return;
                  this.onShiftSelectionChanged(e);
                },
              },
              validationRules: [
                {
                  type: "required",
                  message: "Shift is required",
                },
              ],
            },
            {
              dataField: "ShiftExceptionReasonRecordID",
              label: { text: "Exception Reason", location: "left" },
              editorType: "dxSelectBox",
              colSpan: 1,
              editorOptions: {
                tabIndex: 3,
                dataSource: ProcessCapacityService.dataSourceConfig(
                  "api/ShiftExceptionReasonList",
                  {
                    filter: [["Inactive", "=", "N"]],
                    sort: "Name asc",
                    select: "ShortCode, Name, RecordId",
                    keyType: {
                      RecordId: "Guid",
                    },
                    fieldType: {
                      RecordId: "Guid",
                    },
                  },
                ),
                displayExpr: (item) => {
                  if (item) return item.ShortCode + " - " + item.Name;
                  else return "";
                },
                valueExpr: "RecordId",
                searchEnabled: true,
                searchExpr: ["Name", "ShortCode"],
                searchMode: "contains",
                itemTemplate: (data) => {
                  return ` <div class="custom-auto-complete" id="${data.RecordId}" >
                  <span class="auto-complete-primary">
                    ${data.ShortCode}
                    </span>
                    <span class="record-secondary gc-grid-code">
                      ${data.Name}
                  </span>
                </div>`;
                },
                dropDownOptions: {
                  minWidth: 200,
                },
              },
              validationRules: [
                {
                  type: "required",
                  message: "Exception Reason is required",
                },
              ],
            },
            {
              dataField: "Action",
              label: { text: "Action", location: "left" },
              editorType: "dxSelectBox",
              colSpan: 1,
              editorOptions: {
                tabIndex: 4,
                dataSource: [
                  {
                    type: "RemoveShiftInstance",
                    Name: "Remove Shift Instance",
                  },
                  { type: "AlterShiftInstance", Name: "Alter Shift Instance" },
                ],
                displayExpr: "Name",
                valueExpr: "type",
              },
              validationRules: [
                {
                  type: "required",
                  message: "Action is required",
                },
              ],
            },
            // Second Row: Start Time, End Time, Shift Duration (each 1 column)
            {
              dataField: "DateStart",
              label: { text: "Start Date", location: "left" },
              editorType: "dxDateBox",
              colSpan: 1,
              editorOptions: {
                width: "100%",
                displayFormat: "d MMM yyyy",
                tabIndex: 5,
                type: "date",
                onValueChanged: this.onDateStartChange,
                placeholder: "Select Date",
              },
              validationRules: [
                {
                  type: "required",
                  message: "Start Date is required",
                },
              ],
            },
            {
              dataField: "DateEnd",
              label: { text: "End Date", location: "left" },
              editorType: "dxDateBox",
              colSpan: 1,
              required: this.model.Action === "AlterShiftInstance",
              visible: this.popupConfig.formMode === "create",
              editorOptions: {
                width: "100%",
                displayFormat: "d MMM yyyy",
                tabIndex: 6,
                type: "date",
                onValueChanged: this.onDateEndChange,
                min: this.model.DateStart,
                placeholder: "Select Date",
              },
            },
          ],
        },
        {
          itemType: "group",
          caption: "",
          colCount: 2,
          visible: this.IsProcessException === false,
          items: [
            {
              dataField: "StartTime",
              label: { text: "Start Time", location: "left" },
              editorType: "dxDateBox",
              colSpan: 1,
              visible: this.model.Action === "AlterShiftInstance",
              editorOptions: {
                width: "100%",
                displayFormat: "HH:mm",
                tabIndex: 7,
                type: "time",
                onValueChanged: this.onStartTimeChange,
                placeholder: "Select Time",
                useMaskBehavior: true,
                onInput: (e) => {
                  const inputElement = e.event.target;
                  const val = inputElement.value;

                  if (this.model.StartTime === null && val) {
                    const hour = val.split(":")[0];
                    if (hour && !isNaN(hour)) {
                      const newTime = new Date();
                      newTime.setHours(parseInt(hour), 0, 0, 0);
                      e.component.option("value", newTime);
                    }
                  }
                },
                onKeyDown: (e) => {
                  if (!e.event) return;
                  if (forwardTabbing(e)) {
                    e.event.preventDefault();
                    setTimeout(() => {
                      this.$nextTick(() => {
                        if (this.model.Action === "RemoveShiftInstance") {
                          this.setFocusOnField("Comment");
                        } else {
                          this.setFocusOnField("EndTime");
                        }
                      });
                    }, 10);
                  }
                },
              },
              validationRules: [
                {
                  type: "required",
                  message: "Start Time is required",
                },
              ],
            },
            {
              dataField: "EndTime",
              label: { text: "End Time", location: "left" },
              editorType: "dxDateBox",
              colSpan: 1,
              visible: this.model.Action === "AlterShiftInstance",
              editorOptions: {
                width: "100%",
                displayFormat: "HH:mm",
                tabIndex: 8,
                type: "time",
                onValueChanged: this.onEndTimeChange,
                placeholder: "Select Time",
                onInput: (e) => {
                  const inputElement = e.event.target;
                  const val = inputElement.value;

                  if (this.model.EndTime === null && val) {
                    const hour = val.split(":")[0];
                    if (hour && !isNaN(hour)) {
                      const newTime = new Date();
                      newTime.setHours(parseInt(hour), 0, 0, 0);
                      e.component.option("value", newTime);
                    }
                  }
                },
                onKeyDown: (e) => {
                  if (!e.event) return;
                  if (forwardTabbing(e)) {
                    e.event.preventDefault();
                    this.$nextTick(() => {
                      this.setFocusOnField("Comment");
                    });
                  }
                },
              },
              validationRules: [
                {
                  type: "required",
                  message: "End Time is required",
                },
              ],
            },
          ],
        },
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: [
            {
              dataField: "Comment",
              label: { text: "Description", location: "left" },
              editorType: "dxTextBox",
              colSpan: 1,
              editorOptions: {
                tabIndex: 9,
                maxLength: 200,
                onKeyDown: async (e) => {
                  if (!e.event) return;
                  if (forwardTabbing(e)) {
                    e.event.preventDefault();
                    if (!this.IsProcessException) return;
                    if (!this.model.ShiftRecordID || !this.model.Action) {
                      await this.$alert(
                        `Please select Shift and Action before selecting Process.`,
                        "Validation Error",
                      );

                      this.setFocusOnField(
                        !this.model.ShiftRecordID ? "ShiftRecordID" : "Action",
                      );
                    } else {
                      this.$nextTick(() => {
                        if (this.popupConfig.formMode === "edit") {
                          if (this.model.Action === "AlterShiftInstance") {
                            this.focusOnEditableGridCell("StartTime");
                          } else return;
                        } else this.focusOnEditableGridCell("ProcessCode");
                      });
                    }
                  }
                },
              },
            },
          ],
        },
        {
          itemType: "group",
          caption: "",
          colCount: 2,
          items: [
            {
              dataField: "ManageDowntime",
              visible:
                this.IsShiftException &&
                this.model.Action === "AlterShiftInstance",
              label: {
                text: " ",
                visible: false,
              },
              editorType: "dxButton",
              cssClass: "btn-manage-downtime",
              editorOptions: {
                onClick: async () => {
                  this.onManageShiftExceptionDowntimeClick();
                },
                text: "Manage Downtime",
                allowUpdate: true,
                type: "normal",
                tabIndex: 10,
              },
            },
          ],
        },
      ];
    },

    isProcessDownTimeEditable() {
      return (
        this.ShiftRecordID &&
        this.model.Action === "AlterShiftInstance" &&
        this.IsProcessException
      );
    },

    /**
     * Get Toolbar Items
     */
    getToolbarItems() {
      return [
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: this.popupConfig.formMode === "review",
          options: {
            icon: "clock",
            onClick: this.onAuditPopupHandler,
          },
        },
        {
          widget: "dxDropDownButton",
          location: "after",
          toolbar: "top",
          visible: this.popupConfig.formMode === "review",
          options: {
            items: [
              {
                menuText: "Remove Exception",
                disabled: !FeatureStorage.checkPermission(
                  "ProcessCapacity",
                  "create",
                ),
                onClick: this.onRemoveExceptionHandler,
              },
            ],
            icon: "fas fa-ellipsis-v",
            showArrowIcon: false,
            stylingMode: "text",
            dropDownOptions: {
              minWidth: 150,
            },
            displayExpr: "menuText",
            valueExpr: "menuText",
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible:
            this.popupConfig.formMode === "review" &&
            FeatureStorage.checkPermission("ProcessCapacity", "edit"),
          options: {
            icon: "edit",
            onClick: this.onEditPopupHandler,
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: this.popupConfig.formMode !== "review",
          options: {
            text: "Save",
            stylingMode: "contained",
            type: "default",
            onClick: this.onSavePopupHandler,
            visible: this.popupConfig.formMode !== "review",
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          // visible: this.popupConfig.formMode !== "review",
          options: {
            icon: "close",
            onClick: this.onCancelPopupHandler,
            // visible: this.popupConfig.formMode !== "review",
          },
        },
      ];
    },

    getFormInstance() {
      if (
        this.$refs["gc-form-comp-shifts"] &&
        this.$refs["gc-form-comp-shifts"].$refs["gc-form-comp"]
      ) {
        return this.$refs["gc-form-comp-shifts"].$refs["gc-form-comp"];
      } else {
        return null;
      }
    },

    getShiftRecordID() {
      return this.ShiftRecordID ? this.ShiftRecordID._value : null;
    },

    getColumns() {
      return [
        {
          caption: "Code",
          dataField: "ProcessCode",
          minWidth: ColumnWidth.Code.minWidth,
          width: ColumnWidth.Code.width,
          cssClass: "edit-cell-textbox-field description-column",
          editorType: "dxSelectBox",
          editorOptions: {
            dataSource: ProcessCapacityService.dataSourceConfig(
              "api/ProcessShiftRecurring",
              {
                filter: [["ShiftRecordID", "=", this.getShiftRecordID]],
                sort: "ProcessCode asc",
                select:
                  "ProcessCode,ProcessName, ShiftRecordID, RecordId, StartTime, EndTime, ProcessRecordId",
                keyType: {
                  RecordId: "Guid",
                  ShiftRecordID: "Guid",
                },
                fieldType: {
                  RecordId: "Guid",
                  ShiftRecordID: "Guid",
                },
                postProcess: (data) => {
                  let grid = this.dataGrid;
                  let records = grid.getDataSource().items();

                  records.forEach((element) => {
                    data.forEach((item, index) => {
                      if (data && data.ProcessCode === item.ProcessCode) {
                        return;
                      }
                      if (element.ProcessCode == item.ProcessCode) {
                        data[index].disabled = true;
                      }
                    });
                  });

                  return this.uniqueProcesses(data);
                },
              },
            ),
            displayExpr: "ProcessCode",
            valueExpr: "ProcessCode",
            searchEnabled: true,
            searchExpr: ["ProcessCode", "ProcessName"],
            itemTemplate: (data) => {
              return ` <div class="custom-auto-complete" id="${data.ProcessCode}" >
                  <span class="auto-complete-primary">
                    ${data.ProcessName}
                  </span>
                  <span class="record-secondary gc-grid-code">
                    ${data.ProcessCode}
                  </span>
                </div>`;
            },
            dropDownOptions: {
              minWidth: 200,
            },
            onFocusIn: async (e) => {
              if (!e.event) return;
              e.event.target.select();

              if (!this.model.ShiftRecordID || !this.model.Action) {
                await this.$alert(
                  `Please select Shift and Action before selecting Process.`,
                  "Validation Error",
                );

                this.setFocusOnField(
                  !this.model.ShiftRecordID ? "ShiftRecordID" : "Action",
                );
              }
            },

            onOpened: (e, context) => {
              var data = context.data;
              e.component.beginUpdate();

              var items = e.component.getDataSource().items();
              items.forEach((item) => {
                item.disabled = false;
                e.component.option("items", items);
              });

              let grid = this.dataGrid;
              let records = grid.getDataSource().items();

              records.forEach((element) => {
                items.forEach((item, index) => {
                  if (data && data.ProcessCode === item.ProcessCode) {
                    return;
                  }
                  if (element.ProcessCode == item.ProcessCode) {
                    items[index].disabled = true;
                    e.component.option("items", items);
                  }
                });
              });
              e.component.endUpdate();
            },
            onValueChanged: (e, lineData) => {
              if (!e.event) return;
              var items = e.component.getDataSource().items();
              var item = items.filter((x) => x.ProcessCode == e.value);

              if (item && item.length > 0) {
                this.ProcessShiftExceptionDataSource.update(lineData.data.id, {
                  ProcessDescription: item[0].ProcessName,
                  ProcessRecordId: item[0].ProcessRecordId,
                  StartTime: item[0].StartTime ? item[0].StartTime : null,
                  EndTime: item[0].EndTime ? item[0].EndTime : null,
                });
              } else {
                this.ProcessShiftExceptionDataSource.update(lineData.data.id, {
                  ProcessDescription: null,
                  ProcessRecordId: null,
                  StartTime: null,
                  EndTime: null,
                });
              }

              this.dataGrid.cellValue(
                lineData.rowIndex,
                "ProcessCode",
                item.length > 0 ? item[0].ProcessCode : null,
              );

              this.$nextTick(() => {
                this.dataGrid.closeEditCell();
                setTimeout(() => {
                  if (this.model.Action !== "AlterShiftInstance") {
                    this.forwardTabFromProcessCode(lineData);
                  } else {
                    this.dataGrid.focus(
                      this.dataGrid.getCellElement(
                        lineData.rowIndex,
                        "StartTime",
                      ),
                    );
                    this.dataGrid.editCell(lineData.rowIndex, "StartTime");
                  }
                }, 100);
              });
            },

            onKeyDown: (e, lineData) => {
              if (!e.event) return;
              if (backwardTabbing(e)) {
                if (lineData.rowIndex === 0) {
                  e.event.preventDefault();
                  this.$nextTick(() => {
                    this.setFocusOnField("Comment");
                  });
                } else if (this.model.Action !== "AlterShiftInstance") {
                  e.event.preventDefault();
                  this.dataGrid.focus(
                    this.dataGrid.getCellElement(
                      lineData.rowIndex - 1,
                      "ProcessCode",
                    ),
                  );
                  this.dataGrid.editCell(lineData.rowIndex - 1, "ProcessCode");
                }
              }

              if (
                forwardTabbing(e) &&
                this.model.Action !== "AlterShiftInstance"
              ) {
                e.event.preventDefault();
                this.$nextTick(() => {
                  this.forwardTabFromProcessCode(lineData);
                });
              }
            },
          },
          setCellValue: async (newData, value, currentRowData) => {
            if (
              !currentRowData.ProcessCode &&
              this.popupConfig.formMode !== "edit"
            ) {
              this.addNewEditableRow();
            }
            newData.ProcessCode = value;

            return newData;
          },
        },
        {
          caption: "Description",
          dataField: "ProcessDescription",
          width: "100%",
          minWidth: 200,
          allowEditing: false,
        },
        {
          caption: "Start Time",
          dataField: "StartTime",
          minWidth: ColumnWidth.Time.minWidth,
          width: ColumnWidth.Time.width,
          dataType: "datetime",
          format: "HH:mm",
          cssClass: "edit-cell-datebox-field",
          editorOptions: {
            type: "time",
            pickerType: "list",
            displayFormat: "HH:mm",
            useMaskBehavior: true,
            placeholder: "Select Time",
            onKeyDown: (e) => {
              if (!e.event) return;

              if (backwardTabbing(e) && this.popupConfig.formMode === "edit") {
                e.event.preventDefault();
                this.$nextTick(() => {
                  this.setFocusOnField("Comment");
                });
              }
            },
            onInput: (e, context) => {
              this.normalizeTimeInput(e, context, {
                dataSource: this.ProcessShiftExceptionDataSource,
                flagField: "StartTimeEnter",
              });
            },
          },
          setCellValue: (newData, value) => {
            newData.StartTime = value;
            newData.EndTime = null;
            newData.EndTimeEnter = false;
            return newData;
          },
          cellTemplate: (data, info) => {
            if (info.data.HasUniqueShiftWindow === false) {
              return (data.innerHTML = `<div class='time-cell-template disabled-cell'> - </div>`);
            } else
              return (data.innerHTML = `<div class='time-cell-template'>${info.text}</div>`);
          },
        },
        {
          caption: "End Time",
          dataField: "EndTime",
          minWidth: ColumnWidth.Time.minWidth,
          width: ColumnWidth.Time.width,
          dataType: "datetime",
          format: "HH:mm",
          cssClass: "edit-cell-datebox-field",
          editorOptions: {
            type: "time",
            placeholder: "Select Time",
            pickerType: "list",
            displayFormat: "HH:mm",
            useMaskBehavior: true,
            onInput: (e, context) => {
              this.normalizeTimeInput(e, context, {
                dataSource: this.ProcessShiftExceptionDataSource,
                flagField: "EndTimeEnter",
              });
            },
          },
          setCellValue: (newData, value) => {
            newData.EndTime = value;
            return newData;
          },
          cellTemplate: (data, info) => {
            if (info.data.HasUniqueShiftWindow === false) {
              return (data.innerHTML = `<div class='time-cell-template disabled-cell'> - </div>`);
            } else
              return (data.innerHTML = `<div class='time-cell-template'>${info.text}</div>`);
          },
        },
        {
          caption: "",
          dataField: "ManageDownTime",
          minWidth: 150,
          width: 150,
          cellTemplate: "manageDownTimeCellTemplate",
          showEditorAlways: false,
          visible: this.model.Action === "RemoveShiftInstance" ? false : true,
          allowEditing: false,
        },
        {
          dataField: "",
          caption: "",
          type: "buttons",
          buttons: [
            {
              hint: "Delete",
              icon: "trash",

              visible: this.popupConfig.formMode !== "review",
              onClick: async (e) => {
                const confirmDelete = await this.$confirm(
                  "Are you sure you want to delete this entry?",
                  "Delete Entry",
                );
                if (confirmDelete) {
                  this.dataGrid.deleteRow(e.row.rowIndex);
                }
              },
            },
          ],
          visible: this.popupConfig.formMode !== "review",
          width: 50,
          minWidth: 50,
        },
      ];
    },

    getDataSource() {
      return this.ProcessShiftExceptionDataSource._array;
    },

    dataGrid() {
      if (this.$refs["shifts-tab-grid-downtime"]) {
        return this.$refs["shifts-tab-grid-downtime"].instance;
      } else {
        return null;
      }
    },

    getPopupHeight() {
      if (this.IsProcessException) {
        return 700;
      } else {
        return this.popupHeight;
      }
    },
  },
  watch: {
    getHotKeySave: {
      handler(val) {
        if (val) {
          this.$store.dispatch("hotKey/setHotKeySave", false);
          this.onSavePopupHandler();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
.gc-popup-shifts {
  .dx-toolbar.dx-popup-title {
    height: 60px;
  }

  .toolbar-title-secondary {
    padding-left: unset !important;
    font-weight: 400;
    font-size: 14px;
  }

  .gc-text-area-large {
    label.dx-field-item-label {
      padding-top: 4px;
    }
    textarea.dx-texteditor-input {
      padding-top: unset !important;
    }
  }

  .gc-popup-form {
    .gc-tag-box {
      .dx-tagbox:not(.dx-texteditor-empty):not(.dx-editor-filled):not(
          .dx-editor-outlined
        )::after {
        border-bottom: 1px solid rgba(0, 0, 0, 0.42) !important;
      }
    }
  }

  .gc-popup-data-grid {
    padding-top: unset !important;
    .dx-datagrid-header-panel {
      height: 0px !important;
    }
    .shift-tabs {
      background-color: white;
    }

    .dx-datagrid .dx-datagrid-content {
      .dx-datagrid-table .dx-row .dx-editor-cell:not(.description-column) {
        padding-right: 5px !important;
        padding-left: 5px !important;
      }

      .dx-datebox {
        .dx-placeholder::before {
          padding-left: unset !important;
          padding-bottom: unset !important;
          padding-top: unset !important;
        }
      }

      // .dx-datebox.dx-texteditor:not(.dx-state-readonly)::after {
      //   content: "";
      //   border-bottom: 1px solid rgba(0, 0, 0, 0.42) !important;
      // }
    }

    tr.dx-data-row {
      > td.edit-cell-textbox-field.description-column {
        padding-left: 18px !important;
      }
    }

    .time-cell-template.disabled-cell {
      text-align: center;
    }

    .overrid-downtime-switch {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .dx-switch {
        padding-left: 5px;
      }

      .dx-icon.dx-icon-edit {
        margin-right: 10px !important;
      }

      .dx-button-text {
        font-size: 8px;
        // padding-left: 10px;
      }
    }
  }

  .btn-manage-downtime {
    padding-top: 5px !important;
    gap: 20px;
  }

  .manage-downtime {
    display: flex;
    align-items: center;
    justify-content: center;

    .dx-button-text {
      font-size: 8px;
    }
  }
}
</style>
